import { apiRequest } from "@alba-cars/common-modules";

import { PaginatedResponse } from "@/components/common/forms/FormAutoComplete";

export interface DealDriveSpec {
  node: {
    id: number;
    name: string;
  };
}

export const getDealDriveSpecs = async (search?: string) => {
  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.append("search", search);
  }

  const response = await apiRequest<DealDriveSpec[]>(`/dealdrive/specs${search ? `?${queryParams.toString()}` : ""}`, {
    next: {
      revalidate: 3600, // Cache for 1 hour
      tags: ["dealdrive-specs"],
    },
  });

  return response;
};

export const getDealDriveSpecsPaginated = async (
  inputValue: string,
  _page?: number,
  _filter?: Record<string, string>,
): Promise<PaginatedResponse<{ label: string; value: string }>> => {
  try {
    const specs = await getDealDriveSpecs(inputValue);

    const formattedSpecs = specs.map((spec) => ({
      label: spec.node.name,
      value: spec.node.id.toString(),
    }));

    return {
      data: formattedSpecs,
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  } catch (error) {
    console.error("Error fetching DealDrive specs:", error);
    return {
      data: [],
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  }
};
